// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Connection } from '@shared/commons/Connection';
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraMessageBoxTemplate from '@front/templates/TerceraMessageBoxTemplate.html';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from './TerceraMessageBox';
export class TerceraTimeoutMessageBox extends TerceraMessageBox {
    constructor() {
        super(...arguments);
        this.forceCloseOnLogout = false;
        this.OK_Handler = null;
        this.NO_Handler = null;
        this.countingTimer = null;
    }
    static Show() {
        const mBox = new TerceraTimeoutMessageBox();
        void mBox.set({
            messageBoxType: MessageBoxType.Warning,
            header: Resources.getResource('disconnectMessageBox.Header'),
            messageBoxText: Resources.getResource('disconnectMessageBox.Text').replace('{0}', '30'),
            showNextTimeChB: false,
            okText: Resources.getResource('disconnectMessageBox.logoutButton'),
            cancelText: Resources.getResource('disconnectMessageBox.cancelButton'),
            okToolTop: Resources.getResource('disconnectMessageBox.logoutButton.descr'),
            cancelToolTop: Resources.getResource('disconnectMessageBox.cancelButton.descr')
        });
        MainWindowManager.AddControl(mBox);
        mBox.OK_Handler = new Promise(function (resolve) {
            mBox.OkClicked = resolve;
        });
        mBox.NO_Handler = new Promise(function (resolve) {
            mBox.CancelClicked = resolve;
        });
        mBox.StartCounting();
        return mBox;
    }
    StartCounting() {
        this.startTime = new Date();
        this.countingTimer = setInterval(this._Counting.bind(this), 200);
    }
    _Counting() {
        if (!Connection.isConnectionCorrect()) // #93043
         {
            this.cancelClick();
            return;
        }
        const dif = 30 - new Date(new Date().getTime() - this.startTime.getTime()).getSeconds();
        if (dif < 0) {
            this.okClick();
            return;
        }
        const locVal = Resources.getResource('disconnectMessageBox.Text');
        const Text = locVal.replace('{0}', dif.toString());
        void this.set({ messageBoxText: Text });
    }
    StopCounting() {
        clearInterval(this.countingTimer);
    }
    okClick() {
        if (!isNullOrUndefined(this.OkClicked)) {
            this.OkClicked();
        }
        this.StopCounting();
        this.close();
    }
    cancelClick() {
        if (!isNullOrUndefined(this.CancelClicked)) {
            this.CancelClicked();
        }
        this.StopCounting();
        this.close();
    }
}
TerceraMessageBox.extendWith(TerceraTimeoutMessageBox, {
    data: function () {
        return {};
    },
    partials: { bodyPartial: TerceraMessageBoxTemplate }
});
